import { render, staticRenderFns } from "./VxSidebarGroup.vue?vue&type=template&id=253f3d2e&"
import script from "./VxSidebarGroup.vue?vue&type=script&lang=js&"
export * from "./VxSidebarGroup.vue?vue&type=script&lang=js&"
import style0 from "./VxSidebarGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253f3d2e')) {
      api.createRecord('253f3d2e', component.options)
    } else {
      api.reload('253f3d2e', component.options)
    }
    module.hot.accept("./VxSidebarGroup.vue?vue&type=template&id=253f3d2e&", function () {
      api.rerender('253f3d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vx-sidebar/VxSidebarGroup.vue"
export default component.exports